import React from 'react';
import GlobalStyles from './styles/GlobalStyles';
import Routess from './routes.js';

function App() {
  return (
    <>
      <Routess />
      <GlobalStyles />
    </>
  );
}

export default App;
